/**
 * Clear Banner Alert Action - WHAT Section
 *
 * Clears all active banner alerts for matched clients.
 * No specific alert selection needed.
 *
 * V2 Reference: v2/app/templates/components/client-reminder-clear-banner-alert.hbs
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'src/components/Typography';

import { ActionWhatSectionProps } from '../automationActions';

export const ClearBannerAlertWhatSection: FC<ActionWhatSectionProps> = () => {
  const { t } = useTranslation();

  return (
    <Typography color="text.secondary" fontStyle="italic">
      {t('automations.clearBannerAlert.description')}
    </Typography>
  );
};

export const ClearBannerAlertWhatSummary: FC<{
  automation: ActionWhatSectionProps['automation'];
}> = () => {
  const { t } = useTranslation();

  return <>{t('automations.clearBannerAlert.summary')}</>;
};
